/*
  Photo galleries: the product cards on the products page and the big
  gallery on the product page. Photos sit side by side in a track that
  snaps one photo at a time; swipe / trackpad works natively, and these
  listeners handle the ‹ › arrows (wrapping around at the ends) and keep the
  "1/3" counter in step.

  Markup: [data-zp-card] around [data-zp-card-track], arrows with
  data-zp-card-step="-1" / "1", and a [data-zp-card-index] counter.
*/
(() => {
  const indexOf = (track) => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-zp-card-step]');
    if (!arrow) return;
    const gallery = arrow.closest('[data-zp-card]');
    const track = gallery && gallery.querySelector('[data-zp-card-track]');
    if (!track) return;
    const count = track.children.length;
    const next = (indexOf(track) + Number(arrow.dataset.zpCardStep) + count) % count;
    track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
  });

  // Scroll events don't bubble, so listen in the capture phase for every track at once.
  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target;
      if (!(track instanceof Element) || !track.matches('[data-zp-card-track]')) return;
      const gallery = track.closest('[data-zp-card]');
      const label = gallery && gallery.querySelector('[data-zp-card-index]');
      if (label) label.textContent = String(indexOf(track) + 1);
    },
    { capture: true, passive: true }
  );
})();
